.field {
  width: 100%;
}

.input,
.select {
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
  /* 16px, not 15: below 16 iOS Safari zooms the page into a focused field, and the viewport no
     longer forbids zoom (BUG-11) — the sheet would stay zoomed and clipped after blur. */
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
}

.select {
  appearance: none;
}

.select option {
  color: #000000;
}

.input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.input:focus,
.select:focus {
  border-color: rgba(204, 255, 0, 0.6);
}

.note {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-sizing: border-box;
}

.error {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 60, 60, 0.14);
  border: 1px solid rgba(255, 60, 60, 0.4);
  box-sizing: border-box;
}
